import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const EntityLinkWidget: WidgetRegistryEntry = {
  name: "EntityLink",
  configuration: () => import("./configuration").then((m) => m.EntityLinkWidgetConfiguration),
  component: () => import("./entity-link-widget.component").then((m) => m.EntityLinkWidgetComponent)
};
